import { Card, List } from "antd";
import Item from "./components/Item";

const MasterIssue = ({ master_issue, refetch }) => (
  <Card
    styles={{
      body: {
        padding: "0 24px",
      },
    }}
    style={{ marginBottom: 24 }}
    title="Zgłoszenie należy do:"
  >
    <List
      itemLayout="horizontal"
      dataSource={[master_issue]}
      renderItem={(item) => <Item {...item} refetch={refetch} />}
    />
  </Card>
);

export default MasterIssue;
